//
import React, { useLayoutEffect, useRef, useState } from 'react';

import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material/styles';

import ErrorBoundary from 'components/ErrorBoundary';

/**
 * StdDialogContent should be used instead of the MUI DialogContent. StdDialogContent is a thin wrapper whose primary purpose
 * is to add scrolling support if content is larger than height constraint assigned by parent. In the case where scrollable
 * content is available, a fixed divider will automatically be added at the bottom of the content.
 *
 * This component is meant to be used with StdDialog.
 */
const StdDialogContent = (props) => {
  const { children, sx: ferrySx = {}, ...other } = props;
  const theme = useTheme();

  const [requiresScrolling, setRequiresScrolling] = useState(false);

  const contentRef = useRef();
  useLayoutEffect(() => {
    const { current } = contentRef;

    const observer = new ResizeObserver(() => {
      const needsScrolling = current.scrollHeight > current.clientHeight;
      setRequiresScrolling(needsScrolling);
    });
    observer.observe(current);

    return () => observer.disconnect();
  }, []);

  return (
    <DialogContent
      ref={contentRef}
      sx={{
        ...(requiresScrolling && { borderBottom: `1px solid ${theme.palette.divider}` }),
        ...ferrySx,
      }}
      {...other}
    >
      <ErrorBoundary>{children}</ErrorBoundary>
    </DialogContent>
  );
};

export default StdDialogContent;
